import React from "react";
import GMSBorderlessButton from "../../Common/components/GMSBorderlessButton";
import Label from "../../Common/components/Label";
import DatePicker1 from "react-datepicker";

const WeekRepeatSchdule = ({
  repeat,
  weeksInfo,
  scheduleInfo,
  openDatePicker,
  handleWeeklyDataChange,
  formatEndDate,
  setOpenDatePicker,
  setScheduleInfo,
}) => {
  const handleEndDateClick = () => {
    setOpenDatePicker((prev) => !prev);
  };

  const handleEndDateSelection = (date) => {
    const formattedEndDate = formatEndDate(date);
    setScheduleInfo((prevScheduleInfo) => ({
      ...prevScheduleInfo,
      endDate: formattedEndDate,
    }));
    setOpenDatePicker((prev) => !prev);
  };

  const handleClearEndDate = () => {
    setOpenDatePicker((prev) => !prev);
    setScheduleInfo((prevScheduleInfo) => ({
      ...prevScheduleInfo,
      endDate: "",
    }));
  };

  return (
    <div>
      <div className="align-items-center">
        <Label message="Repeat on" fontSize="0.8125" color="#7B7D80" />
        <div className="d-flex mt-2">
          {weeksInfo.map((item, index) => (
            <div
              key={item.code}
              onClick={() => handleWeeklyDataChange(item, item.code)}
              className={`border me-2 ${
                item.selected ? "div-weeks" : ""
              } d-flex justify-content-center align-items-center`}
              style={{
                width: "50px",
                height: "50px",
                borderColor: "#091caa",
              }}
            >
              <label>{item.displayChar}</label>
            </div>
          ))}
        </div>
        <div className="mt-3 d-flex align-items-center">
          <Label message="Occurs every" fontSize="0.75" color="#7B7D80" />
          &nbsp;
          {weeksInfo.map((item) => (
            <div key={item.code} className="mt-0 pt-0">
              <Label message={item.selected ? item.day : ""} fontSize="0.75" />
              &nbsp;
            </div>
          ))}
        </div>
        &nbsp; &nbsp; &nbsp;
        <div className="d-flex align-items-center mt-0">
          <Label message="Until" color="#7B7D80" />
          &nbsp;&nbsp;&nbsp;
          {!openDatePicker && scheduleInfo.endDate === "" && (
            <GMSBorderlessButton
              name={
                scheduleInfo.endDate === ""
                  ? "Choose end date"
                  : scheduleInfo.endDate
              }
              disabled={scheduleInfo.endDate !== ""}
              onClick={handleEndDateClick}
            />
          )}
          {scheduleInfo.endDate !== "" && (
            <Label
              message={scheduleInfo.endDate}
              color="#091CAA"
              fontWeight="400"
              fontSize="0.875"
            />
          )}
          &nbsp;&nbsp;&nbsp;
          {openDatePicker && (
            <DatePicker1
              className="border-0 w-25"
              selected={scheduleInfo.endDate}
              disabled={true}
              minDate={new Date()}
              onChange={handleEndDateSelection}
              open={openDatePicker}
            />
          )}
          {scheduleInfo.endDate !== "" && (
            <GMSBorderlessButton
              name="Select end date"
              onClick={handleClearEndDate}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default WeekRepeatSchdule;
